export const TEMPLATE_TYPES = {
  sla: "SLA Based",
  workflow: "Workflow Based",
} as const;

export type TEMPLATE_TYPE = (typeof TEMPLATE_TYPES)[keyof typeof TEMPLATE_TYPES]; // 'SLA Based' | 'Workflow Based'


export const QUESTION_CONFIG: Record<
  string,
  {
    label: string;
    placeholder: string;
    message: string;
  }
> = {
  file_upload: {
    label: "Add Attachment Title",
    placeholder: "Enter Attachment Title",
    message: "Please enter attachment title",
  },
  default: {
    label: "Add Question Title",
    placeholder: "Enter Question Title",
    message: "Please enter question title",
  },
};

export const MAX_FILE_NUMBERS_OPTIONS = [
  {
    label: "1",
    value: "1",
  },
  {
    label: "2",
    value: "2",
  },
  {
    label: "5",
    value: "5",
  },
];

export const MAX_FILE_SIZE_OPTIONS = [
  {
    label: "5",
    value: "5",
  },
  {
    label: "10",
    value: "10",
  },
  {
    label: "15",
    value: "15",
  },
];